import { MemCommonEditorStore } from "@/components/note/store/MemCommonEditorStore";
import { observer } from "mobx-react-lite";
import { NoteSuggestionActions } from "@/components/note/floating-actions/NoteSuggestionActions";

interface CleanUpActionsProps {
  slot?: string;
  editorStore: MemCommonEditorStore;
}

export const CleanUpActions = observer<CleanUpActionsProps>(function CleanUpActions({
  editorStore,
}) {
  if (!editorStore.noteObservable?.isSuggestionActive) {
    return null;
  }

  return <NoteSuggestionActions editorStore={editorStore} />;
});
